<template>
  <ion-page>
    <ion-content>
      <div class="container-login">
        <router-link to="/usersignup" replace>
          <ion-icon class="back-icon" src="assets/icon/arrow-left.svg" />
        </router-link>
        <h1 class="h1-userlogin">Privacy Policy</h1>
        <h5>Last updated: September 15, 2023</h5>
        <h3>Introduction</h3>
        <span class="span-login"
          >Welcome to OneCoffee ("we," "us," or "our"). At OneCoffee, we are
          committed to protecting your privacy and complying with the Australian
          Privacy Principles (APPs) under the Privacy Act 1988 (Cth). This
          Privacy Policy explains how we collect, use, disclose, and protect
          your personal information when you use our mobile application and
          services (collectively, the "App"). By accessing or using the App, you
          consent to the practices described in this Privacy Policy</span
        >
        <h3>Information We Collect</h3>
        <h5>1. Personal Information</h5>
        <span class="span-login"
          >We may collect the following personal information from you:
        </span>
        <ul>
          <li>
            Name: We may collect your full name to personalize your experience
            within the App.
          </li>
          <li>
            Email Address: Your email address is used for communication purposes
            and account verification.
          </li>
          <li>
            Mobile Number: We collect your mobile number to facilitate account
            recovery and enhance your user experience.
          </li>
          <li>
            Payment Information: If you make in-app purchases or engage in
            transactions through the App, we may collect payment information
            such as credit card details or other payment methods. Please note
            that we do not store your payment information; it is securely
            processed by our third-party payment processors.
          </li>
        </ul>
        <h5>2. Usage Information</h5>
        <span class="span-login"
          >We may collect non-personal information about how you use the
          App,such as:
        </span>
        <ul>
          <li>
            Device Information: We may collect information about your mobile
            device, including its model, operating system, unique device
            identifiers, and mobile network information.
          </li>
          <li>
            Log Data: When you use the App, our servers may automatically record
            information that your device sends, including IP address, browser
            type, and usage patterns.
          </li>
          <li>
            Usage Analytics: We may use analytics tools to collect and analyze
            information about how you interact with the App, such as the pages
            or features you access and the date and time of your visits.
          </li>
        </ul>
        <h5>3. Cookies and Similar Technologies</h5>
        <span class="span-login"
          >We may use cookies, web beacons, and other tracking technologies to
          collect information about your use of the App. These technologies help
          us improve our services and provide a personalized experience. You can
          control the use of cookies through your browser settings.
        </span>
        <h5>4. Location Information</h5>
        <span class="span-login"
          >We may collect and use your device's location information to provide
          location-based services and enhance your experience within the App.
          The collection of location information may occur when you use specific
          features of the App, such as location-based recommendations or
          services. We will only collect location data with your explicit
          consent, which you can typically provide or revoke through your device
          settings or the App.
        </span>
        <span class="span-login">
          We use location data for the following purposes:
        </span>
        <ul>
          <li>
            To provide you with location-based services, such as finding nearby
            points of interest.
          </li>
          <li>
            To improve our services, including analyzing location patterns and
            trends.
          </li>
          <li>
            To personalize your experience within the App based on your
            location.
          </li>
          <li>
            To comply with legal requirements or obligations related to the use
            of location data.
          </li>
        </ul>
        <span class="span-login">
          You can control the collection and sharing of your location
          information through your device settings or the App's settings. Please
          note that if you disable location services, certain features of the
          App may not function as intended.
        </span>
        <span class="span-login"
          >By using the App and providing consent for the collection of location
          data, you agree to the practices described in this section.
        </span>
        <h5>How We Use Your Information</h5>
        <span class="span-login"
          >We use the information we collect for the following purposes:
        </span>
        <ul>
          <li>To provide and maintain the App's functionality.</li>
          <li>To personalize and enhance your experience within the App.</li>
          <li>
            To communicate with you, including responding to your inquiries and
            providing updates about the App.
          </li>
          <li>To process payments and facilitate transactions.</li>
          <li>
            To analyze and improve the App's performance and user experience.
          </li>
          <li>
            To comply with legal obligations and protect our rights and
            interests.
          </li>
        </ul>
        <h5>Disclosure of Your Information</h5>
        <span class="span-login"
          >We may share your personal information with the following
          parties:</span
        >
        <ul>
          <li>
            Service Providers: We may disclose your information to third-party
            service providers who help us operate the App and provide services
            to you.
          </li>
          <li>
            Legal Requirements: We may disclose your information in response to
            legal requests, such as court orders or subpoenas, or to comply with
            applicable laws and regulations.
          </li>
          <li>
            Business Transactions: In the event of a merger, acquisition, or
            sale of all or a portion of our assets, your information may be
            transferred as part of the transaction.
          </li>
        </ul>
        <h5>Cross-Border Data Transfers</h5>
        <span class="span-login"
          >We may transfer personal information to countries outside of
          Australia. When we do, we will take reasonable steps to ensure that
          the data remains protected in accordance with Australian privacy laws.
        </span>
        <h5>Access, Correction, and Complaints</h5>
        <span class="span-login"
          >Under APP 12 and APP 13, you have the right to access and correct
          your personal information held by us. If you have any concerns or
          complaints regarding our handling of your personal information, please
          contact our Privacy Officer at [Privacy Officer's Contact
          Information].
        </span>
        <h5>Data Breach Notification</h5>
        <span class="span-login"
          >We are committed to complying with the Notifiable Data Breaches (NDB)
          scheme. In the event of a data breach likely to result in serious
          harm, we will notify affected individuals and the Office of the
          Australian Information Commissioner (OAIC) as required by law.
        </span>
        <h5>Security</h5>
        <span class="span-login"
          >We take reasonable measures to protect your personal information from
          unauthorized access, disclosure, alteration, and destruction. However,
          no data transmission or storage system can be guaranteed to be 100%
          secure.
        </span>
        <h5>Your Choices</h5>
        <span class="span-login"
          >You have the following choices regarding your personal
          information:</span
        >
        <ul>
          <li>
            Access and Update: You can access and update your personal
            information through the App's settings.
          </li>
          <li>
            Marketing Communications: You can opt out of receiving marketing
            emails from us by following the instructions provided in those
            emails.
          </li>
          <li>
            Data Deletion: You can request the deletion of your account and
            associated personal information by contacting us at [Contact Email
            Address].
          </li>
        </ul>
        <h5>Privacy Policy Updates</h5>
        <span class="span-login"
          >We may update this Privacy Policy from time to time to reflect
          changes in our practices or for other operational, legal, or
          regulatory reasons. We will notify you of any material changes by
          posting the updated Privacy Policy on the App. Your continued use of
          the App after any such changes constitute your acceptance of the
          updated Privacy Policy.
        </span>
        <h5>Contact Us</h5>
        <span class="span-login"
          >If you have any questions, concerns, or requests regarding this
          Privacy Policy or the way we handle your personal information, please
          contact us at support@onecoffeeapp.com.au.
        </span>
        <span class="span-login"
          >By using the App, you signify your acceptance of this Privacy Policy.
          If you do not agree to this Privacy Policy, please do not use the App.
        </span>
        <h5>OneCoffee</h5>
        <h5>One Coffee App Pty Ltd</h5>
        <h5>Your Company Address</h5>
        <h5>support@onecoffeeapp.com.au</h5>
        <h5>Phone Number</h5>
        <h5>Privacy Officer's Contact Information</h5>
        <h5>Contact Email Address</h5>
        <h5>Contact Phone Number</h5>
        <router-link to="/usersignup" replace
          ><ion-button expand="block" color="primary" class="btn-userlogin"
            >Back to SignUp</ion-button
          ></router-link
        >
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import { defineComponent } from "vue";
import { IonContent, IonPage, IonIcon, IonButton } from "@ionic/vue";

export default defineComponent({
  components: { IonContent, IonPage, IonIcon, IonButton },
});
</script>
<style scoped>
.container-login {
  padding: 10%;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 135%;
  color: #666666;
}
.span-login {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 135%;
  color: #666666;
  display: block;
}
.h1-userlogin {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  color: #1b1b1b;
  margin-top: 10%;
  margin-bottom: 10%;
}
.label-userlogin {
  font-family: "Gilroy-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
}
.input-userlogin {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #828282;
  border-bottom: #ebebeb 2px solid;
  margin-bottom: 5%;
}
ion-input.input-userlogin {
  --padding-start: 0px;
}
.btn-userlogin {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  background: #f87e63;
  border-radius: 4px;
  margin-top: 10%;
  margin-bottom: 5%;
  text-transform: none;
  height: 45px;
}
.back-icon {
  height: 20px;
  width: 20px;
}
</style>
